import React from 'react';
import '../components-css/mini-headers.scss'

const MiniHeaders = ({headerName, fontSize = 31}) => {
    return (
        <div className={'spaces'} style={{fontSize: fontSize}}>
            {headerName}
        </div>
    );
};

export default MiniHeaders;
